import config from "config/config";

export const getCompanyNameByBlockCode = (blockCode) => {
  if (!blockCode) {
    return "";
  }
  const companyBlockCodes = JSON.parse(config.COMPANY_BLOCK_CODES);
  return companyBlockCodes[blockCode] || blockCode;
};
